export default __webpack_public_path__ + "static/media/book.8821bdfb.png";